$( function(){
    $('.page-home-testimonial .page-wrap .content').cycle({
        speed: 1000,
        timeout: 8000,
        slides: '.testimonial-wrap',
        prev: '.prev',
        next: '.next',
        fx: 'carousel',
        pager: '.pager',
        carouselVisible: 1,
        carouselFluid: true,
        pagerTemplate: '<a href="" class="pager-item"></a>',
        autoHeight: 'calc',
    });
});